import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock, ShieldCheck, LayoutList } from 'lucide-react';
export function Mechanism() {
  return <section className="bg-white py-20 px-6" data-id="element-129">
      <div className="max-w-6xl mx-auto" data-id="element-130">
        <FadeIn data-id="element-131">
          <div className="text-center mb-16" data-id="element-132">
            <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-133">
              Presentamos el Marco "2 Horas - Todo en Orden"
            </h2>
            <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto" data-id="element-134">
              No es un curso de computación pesado; es un método visual y lógico
              diseñado específicamente para la forma en que tú piensas.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-135">
          <FadeIn delay={0.2} data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/vmNdytgfnCByUSo3w8pZK6/Family_vault.png" alt="El Family Vault Digital" className="rounded-2xl shadow-2xl w-full object-cover" data-id="element-137" />
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-138">
            <div className="space-y-8" data-id="element-139">
              <div className="flex gap-6 items-start" data-id="element-140">
                <div className="bg-cream p-4 rounded-full" data-id="element-141">
                  <LayoutList className="w-8 h-8 text-gold" data-id="element-142" />
                </div>
                <div data-id="element-143">
                  <h4 className="text-2xl font-bold text-navy mb-2" data-id="element-144">
                    Estructura Simple
                  </h4>
                  <p className="text-lg text-gray-700" data-id="element-145">
                    En lugar de aprender tecnología compleja, crearás una
                    "Legado Familiar Digital" estructurado con solo 5 carpetas
                    numeradas.
                  </p>
                </div>
              </div>

              <div className="flex gap-6 items-start" data-id="element-146">
                <div className="bg-cream p-4 rounded-full" data-id="element-147">
                  <ShieldCheck className="w-8 h-8 text-gold" data-id="element-148" />
                </div>
                <div data-id="element-149">
                  <h4 className="text-2xl font-bold text-navy mb-2" data-id="element-150">
                    Fácil de Entender
                  </h4>
                  <p className="text-lg text-gray-700" data-id="element-151">
                    Cualquier persona de tu familia podrá entenderlo al instante
                    cuando más lo necesiten.
                  </p>
                </div>
              </div>

              <div className="flex gap-6 items-start" data-id="element-152">
                <div className="bg-cream p-4 rounded-full" data-id="element-153">
                  <Clock className="w-8 h-8 text-gold" data-id="element-154" />
                </div>
                <div data-id="element-155">
                  <h4 className="text-2xl font-bold text-navy mb-2" data-id="element-156">
                    Rápido de Implementar
                  </h4>
                  <p className="text-lg text-gray-700" data-id="element-157">
                    Diseñado para completarse en bloques de tiempo manejables
                    que suman solo 2 horas en total.
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}